export function formatCurrency(amount, currency) {
    if (!amount || !currency) return '';
    try {
      console.log(amount, currency)  
      const numericValue = parseFloat(amount.toString().replace(/,/g, '')).toFixed(2);

      if (currency === "KRW") {
             // 원화(KRW)는 소수점 없이 ₩ 기호 포함
          return new Intl.NumberFormat("ko-KR", {
            style: "currency",
            currency: "KRW",
            maximumFractionDigits: 0, // 소수점 제거
          }).format(numericValue);
        
      }

      // 다른 통화 (USD, EUR, JPY 등)
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 2, // 소수점 2자리 유지
      }).format(numericValue);
  
    } catch (error) {
      console.error(`Error formatting currency: ${currency}`, error);
      return amount; // 포맷 실패 시 원본 반환
    }
  }
  